import { render } from "./SidebarAccount.vue?vue&type=template&id=41052ddc&ts=true"
import script from "./SidebarAccount.vue?vue&type=script&lang=ts"
export * from "./SidebarAccount.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__